import { render, staticRenderFns } from "./hoursOpen_4.vue?vue&type=template&id=f1f0dd98&scoped=true&"
import script from "./hoursOpen_4.vue?vue&type=script&lang=js&"
export * from "./hoursOpen_4.vue?vue&type=script&lang=js&"
import style0 from "./hoursOpen_4.vue?vue&type=style&index=0&id=f1f0dd98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f0dd98",
  null
  
)

export default component.exports